/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum ClickFinderNodeType {
  None = 'None',
  RootDocumentTypeNode = 'RootDocumentTypeNode',
  RootTagNode = 'RootTagNode',
  DocumentTypeCategory = 'DocumentTypeCategory',
  DocumentType = 'DocumentType',
  TagGroupDefinition = 'TagGroupDefinition',
  TagDefinition = 'TagDefinition',
  SelectionValue = 'SelectionValue',
  StringEquals = 'StringEquals',
  StringStarts = 'StringStarts',
  NumberRange = 'NumberRange',
  Year = 'Year',
  Month = 'Month',
  Day = 'Day',
  Today = 'Today',
  Yesterday = 'Yesterday',
  LastWeek = 'LastWeek',
  NextWeek = 'NextWeek'
}
